import React, { useState } from 'react';

// --- PLACEHOLDER DATA (Replace this with your actual data) ---
const brandStyles = {
    linkHover: '#68A637', 
    primaryGreen: '#91C949',
};

// 1. Define your logos array with at least a 'src' and 'alt' property
const logoData = [
    { id: 1, src: '/images/Home/ComplianceIcons/PlantBased-icon.png', alt: 'Plant-Based' },
    { id: 2, src: '/images/Home/ComplianceIcons/Vegan-icon.png', alt: 'Vegan' },
    { id: 3, src: '/images/Home/ComplianceIcons/SustainableFarming-icon.png', alt: 'Sustainable Farming' },
    { id: 4, src: '/images/Home/ComplianceIcons/GMPCertified-icon.png', alt: 'GMP-Certified' },
    { id: 5, src: '/images/Home/ComplianceIcons/HACCP-icon.png', alt: 'HACCP' },
    { id: 6, src: '/images/Home/ComplianceIcons/USDAOrganic-icon.png', alt: 'USDA Organic' },
    { id: 7, src: '/images/Home/ComplianceIcons/EUOrganic-icon.png', alt: 'EU Organic' },
    { id: 8, src: '/images/Home/ComplianceIcons/NutFree-icon.png', alt: 'Nut-Free' },
    { id: 9, src: '/images/Home/ComplianceIcons/GMOFree-icon.png', alt: 'GMO-Free' },
    { id: 10, src: '/images/Home/ComplianceIcons/AllergenFree-Icon.png', alt: 'Alliance-Free' },
    { id: 11, src: '/images/Home/ComplianceIcons/PesticideFree-icon.png', alt: 'Pesticide-Free' },
    { id: 12, src: '/images/Home/ComplianceIcons/NAF-icon.png', alt: 'No Artificial Flavors' },
    { id: 13, src: '/images/Home/ComplianceIcons/NP-icon.png', alt: 'No Preservatives' },
    { id: 14, src: '/images/Home/ComplianceIcons/SolventFree-icon.png', alt: 'Solvent-Free' },
];

// 2. Define the Logos Per Row constant
const LOGOS_PER_ROW = 7; 


/**
 * Renders a grid of compliance/feature logos, 7 per row, all centered,
 * with a custom tooltip displaying the logo name on hover.
 */
function ComplianceIcons() {
    
    // State to manage the currently hovered logo's details for the tooltip
    const [hoveredLogo, setHoveredLogo] = useState(null); 

    // State to manage the scaling effect for the image itself
    const [hoveredImageId, setHoveredImageId] = useState(null); // Tracks the ID of the image being hovered

    // Function to chunk the main logos array into sub-arrays of size LOGOS_PER_ROW
    const chunkArray = (arr, chunkSize) => {
        const result = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            result.push(arr.slice(i, i + chunkSize));
        }
        return result;
    };

    const logoRows = chunkArray(logoData, LOGOS_PER_ROW);

    // Event handler for mouse entering a logo div
    const handleMouseEnter = (event, logo) => {
        const rect = event.currentTarget.getBoundingClientRect();
        
        // 1. Update tooltip state
        setHoveredLogo({
            name: logo.alt,
            x: rect.left + rect.width / 2, 
            y: rect.top - 10, 
        });

        // 2. Update image scale state
        setHoveredImageId(logo.id);
    };

    // Event handler for mouse leaving a logo div
    const handleMouseLeave = () => {
        // 1. Hide tooltip
        setHoveredLogo(null); 
        
        // 2. Reset image scale state
        setHoveredImageId(null);
    };

    return (
        <section className="container my-5">
            <div className="row">
                <div className="col-12">
                    <h2 className="text-center fw-bold mb-5" 
                        style={{ 
                            color: brandStyles.linkHover,
                            fontSize: 'clamp(1.8rem, 3vw, 2.5rem)' 
                        }}
                    >
                        Compliance
                    </h2>
                </div>
            </div>

            {/* Logo Gallery Container */}
            <div className="container d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                
                {logoRows.map((row, rowIndex) => (
                    <div 
                        key={rowIndex} 
                        className="d-flex justify-content-center align-items-center flex-wrap my-3"
                        style={{ maxWidth: '1200px', width: '100%' }}
                    >
                        {row.map(logo => (
                            <div 
                                key={logo.id} 
                                className="p-2"
                                style={{ 
                                    flexBasis: `${100 / LOGOS_PER_ROW}%`,
                                    maxWidth: `${100 / LOGOS_PER_ROW}%`,
                                    minWidth: '50px',
                                    height: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column', 
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative', 
                                    // Removed the container's transform effect to keep logic simple, 
                                    // focusing the effect on the image itself.
                                }}
                                onMouseEnter={(e) => handleMouseEnter(e, logo)} 
                                onMouseLeave={handleMouseLeave}
                            >
                                <img
                                    src={logo.src}
                                    alt={logo.alt}
                                    className="img-fluid"
                                    style={{ 
                                        maxHeight: '100px',
                                        width: 'auto',
                                        opacity: hoveredImageId === logo.id ? 1 : 0.8, // Full opacity on hover
                                        filter: hoveredImageId === logo.id ? 'grayscale(0%)' : 'grayscale(100%)', // Color on hover
                                        
                                        // --- NEW: Scaling the image based on hover state ---
                                        transform: hoveredImageId === logo.id ? 'scale(1.2)' : 'scale(1)', // Scale up 20%
                                        transition: 'transform 0.3s ease, filter 0.3s ease, opacity 0.3s ease', // Smooth transition
                                    }}
                                />
                                
                                {/* Custom Tooltip for this logo */}
                                {hoveredLogo && hoveredLogo.name === logo.alt && (
                                    <div 
                                        style={{
                                            position: 'fixed', 
                                            top: hoveredLogo.y,
                                            left: hoveredLogo.x,
                                            transform: 'translate(-50%, -100%)', 
                                            backgroundColor: 'white',
                                            color: brandStyles.linkHover, 
                                            padding: '8px 12px',
                                            borderRadius: '5px',
                                            whiteSpace: 'nowrap',
                                            pointerEvents: 'none', 
                                            zIndex: 1000, 
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                            fontSize: '0.9rem',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {hoveredLogo.name}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}

export default ComplianceIcons;